import { render, staticRenderFns } from "./AddEditInfo.vue?vue&type=template&id=18bd1184&scoped=true"
import script from "./AddEditInfo.vue?vue&type=script&lang=js"
export * from "./AddEditInfo.vue?vue&type=script&lang=js"
import style0 from "./AddEditInfo.vue?vue&type=style&index=0&id=18bd1184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd1184",
  null
  
)

export default component.exports